import { axios } from '../../clients/axios'
import nodeFormData from 'form-data'

const propertyLogHeaders = [
  { text: 'User', value: 'tenant_details.username' },
  { text: 'Date', value: 'date' },
  { text: 'Action', value: 'log' }
]

export default {
  namespaced: true,
  state: {
    property: null,
    selectedProperties: null,
    propertyLogs: []
  },
  getters: {
    getProperty: (state) => {
      return state.property
    },
    getSelectedProperties: (state) => {
      return state.selectedProperties
    },
    getPropertyLogs: (state) => {
      return state.propertyLogs
    },
    getPropertyLogHeaders: () => {
      return propertyLogHeaders
    }
  },
  mutations: {
    fetchProperty(state, property) {
      state.property = property
    },
    fetchSelectedProperties(state, selectedProperties) {
      state.selectedProperties = selectedProperties
    },
    fetchPropertyLogs(state, propertyLogs) {
      state.propertyLogs = propertyLogs
    }
  },
  actions: {
    async newPropertyAction(context, params) {
      try {
        const {
          propertyName,
          address1,
          address2,
          contactNumber1,
          email1,
          logo
        } = params
        const form = new nodeFormData()

        form.append('propertyName', propertyName)
        form.append('address1', address1)
        form.append('address2', address2)
        form.append('contactNumber1', contactNumber1)
        form.append('email1', email1)
        form.append('logo', logo)

        // const property = await axios.post(`${process.env.VUE_APP_API_URL}/properties`,
        //   { propertyName, address1, address2, contactNumber1, email1 },
        //   { withCredentials: true }
        // )

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        const property = await axios.post(
          `${process.env.VUE_APP_API_URL}/properties`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(property.data)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async fetchPropertyAction(context) {
      const property = await axios.get(
        `${process.env.VUE_APP_API_URL}/properties`,
        { withCredentials: true }
      )

      if (property && property.data) {
        context.commit('fetchProperty', property.data)
        localStorage.setItem('property', property.data.status)
        localStorage.setItem(
          'subscriptionStart',
          property.data.subscriptionStart
        )
        localStorage.setItem('subscriptionEnd', property.data.subscriptionEnd)
      }

      return property.data
    },
    async fetchSelectedPropertiesAction(context, params) {
      let userId = -1
      if (Number.isInteger(params.userId)) {
        userId = params.userId
      }
      const selectedProperties = await axios.get(
        `${process.env.VUE_APP_API_URL}/properties/user/${userId}`,
        { withCredentials: true }
      )

      context.commit('fetchSelectedProperties', selectedProperties.data)

      return selectedProperties.data
    },
    async approvePropertyAction(context, params) {
      const {
        propertyId,
        startDate,
        endDate,
        userLimit,
        sendSMS,
        sendEmail,
        payOnline
      } = params
      const selectedProperty = await axios.post(
        `${process.env.VUE_APP_API_URL}/properties/approve`,
        {
          propertyId,
          startDate,
          endDate,
          userLimit,
          sendSMS,
          sendEmail,
          payOnline
        },
        { withCredentials: true }
      )

      // context.commit('fetchSelectedProperties', selectedProperty.data)

      return selectedProperty.data
    },
    async updatePropertyLogoAction(context, params) {
      try {
        const form = new nodeFormData()
        const { logo } = params

        form.append('logo', logo)

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        const property = await axios.put(
          `${process.env.VUE_APP_API_URL}/properties/logo`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(property.data)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async addUserPropertyAction(context, params) {
      try {
        const { username, roleId } = params

        const property = await axios.put(
          `${process.env.VUE_APP_API_URL}/properties/add/${context.state.property.propertyId}`,
          {
            username: username,
            roleId: roleId,
            propertyId: context.state.property.propertyId
          },
          { withCredentials: true }
        )

        return Promise.resolve(property)
      } catch (err) {
        let response = ''
        if (err.response.data === 'USER_LIMIT_ERROR') {
          response =
            'Your property has exceeded the user limit. You may contact the developers to increase user limit.'
        } else if (err.response.data === 'USER_ALREADY_ENROLLED_ERROR') {
          response = 'The user is already managing a different property.'
        } else if (err.response.data === 'USER_TYPE_ERROR') {
          response = 'The selected user is not a lessor.'
        }
        return Promise.reject(response)
      }
    },
    async removeUserPropertyAction(context, params) {
      try {
        const { userId } = params

        const property = await axios.put(
          `${process.env.VUE_APP_API_URL}/properties/removeUser/${context.state.property.propertyId}`,
          {
            userToRemoveId: userId,
            propertyId: context.state.property.propertyId
          },
          { withCredentials: true }
        )

        return Promise.resolve(property)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async updateUserPropertyAction(context, params) {
      try {
        const { userId, roleId } = params

        const property = await axios.put(
          `${process.env.VUE_APP_API_URL}/properties/updateUserRole/${context.state.property.propertyId}`,
          { userToUpdateId: userId, roleId },
          { withCredentials: true }
        )

        return Promise.resolve(property)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchPropertyLogsAction(context, params) {
      try {
        const { page, limit, sortBy, sortDesc } = params
        let uri = `${process.env.VUE_APP_API_URL}/propertyLogs?page=${
          page - 1
        }&limit=${limit}`

        if (sortBy) {
          uri += `&sortBy=${JSON.stringify(sortBy)}`
        }
        if (sortDesc) {
          uri += `&sortDesc=${JSON.stringify(sortDesc)}`
        }
        const propertyLogs = await axios.get(uri, { withCredentials: true })

        context.commit('fetchPropertyLogs', propertyLogs.data.data)

        return Promise.resolve({
          data: propertyLogs.data.data,
          count: propertyLogs.data.count
        })
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async updatePropertyAction(context, params) {
      try {
        const {
          propertyName,
          email2,
          address1,
          address2,
          contactNumber1,
          contactNumber2,
          // TODO: start of deprecate
          footer,
          dueDaysRental,
          exactDueDateRental,
          useExactDueDate,
          advanceRentalPaymentRequestDays,
          // end of deprecate
          defaults
        } = params

        const property = await axios.patch(
          `${process.env.VUE_APP_API_URL}/properties/update/${context.state.property.propertyId}`,
          {
            propertyName,
            email2,
            address1,
            address2,
            contactNumber1,
            contactNumber2,
            // TODO: start of deprecate
            footer,
            dueDaysRental,
            exactDueDateRental,
            useExactDueDate,
            advanceRentalPaymentRequestDays:
              advanceRentalPaymentRequestDays || 0,
            // end of deprecate
            defaults
          },
          { withCredentials: true }
        )

        return Promise.resolve(property)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async deletePropertyTagAction(context, params) {
      let { propertyId, tag } = params
      try {
        const res = await axios.delete(
          `${process.env.VUE_APP_API_URL}/properties/tags/${propertyId}`,
          {
            data: {
              tag
            },
            withCredentials: true
          },
          { withCredentials: true }
        )

        return Promise.resolve(res)
      } catch (err) {
        if (err.response.status === 401) {
          //logout, maybe
        }
        return Promise.reject(err.response)
      }
    }
  }
}
